import { request } from "./http";

export interface ShortLink {
  id: number;
  user_id: number;
  suffix: string;
  target_url: string;
  title?: string;
  clicks: number;
  created_at: string;
  updated_at: string;
}

export const createShortLink = (targetUrl: string, title?: string) =>
  request<ShortLink>("/api/short-links", {
    method: "POST",
    body: JSON.stringify({ target_url: targetUrl, title }),
  });

export const getShortLinks = () => request<ShortLink[]>("/api/short-links");

export const deleteShortLink = (id: number) =>
  request<{}>(`/api/short-links/${id}`, { method: "DELETE" });

export function getShortLinkUrl(suffix: string): string {
  return `${window.location.origin}/s/${suffix}`;
}
